import { useState } from "react";
import { Toaster } from "react-hot-toast";
import ButtonNavigatorComponent from "../../components/ButtonNavigator";
import { ModalPopUp } from "../../components/ModalPopUp";
import Spinner from "../../components/Spinner";
import { TableComponent } from "../../components/Table v2";
import { _formatDate } from "../../libs/dateUtils";
import { ContentModal } from "./components/ContentModal";
import { FilterRow } from "./components/FilterRow";
import { TableContent } from "./components/TableContent";

import "./index.scss";
import { HistoryContextProvider } from "./store";
import useHistoryStore from "./store/useStore";

export function HistoryPage() {
  return (
    <HistoryContextProvider>
      <HistoryPageList />
    </HistoryContextProvider>
  );
}

function HistoryPageList() {
  const { needSpinner, listRender, listGroupedHistory, needModal, page, selectSize } = useHistoryStore();
  const { setNeedModal, setPage, setSelectSize } = useHistoryStore();

  const [name, setName] = useState("");

  return (
    <>
      <Spinner status={needSpinner}>
        <Toaster />
        <ModalPopUp
          title={`histórico do profissional - ${name}`}
          className="controller-modal"
          status={needModal !== 0}
          onClickCancel={() => setNeedModal(0)}
        >
          {" "}
          <ContentModal listRender={listRender} needModal={needModal} needSpinner={needSpinner} setName={setName} />
        </ModalPopUp>
        <div className="margin-screen">
          <div className="box-title">
            <h1 className="font-poppins"> Histórico </h1>
          </div>

          <FilterRow />
          <TableComponent className="table-container-header-body">
            {listGroupedHistory?.length ? (
              <TableContent />
            ) : (
              <div className="nothing-list flex justify-center width-100">
                <h1>Não há registros para a busca realizada.</h1>
              </div>
            )}
          </TableComponent>

          <Spinner className="mini-spinner" status={needSpinner}>
            {listGroupedHistory?.length ? (
              <ButtonNavigatorComponent
                className="width-select-size"
                list={listGroupedHistory}
                page={page}
                setPage={setPage}
                selectSize={selectSize}
                setSelectSize={setSelectSize}
              />
            ) : (
              ""
            )}
          </Spinner>
        </div>
      </Spinner>
    </>
  );
}
